import NewSkillsPage from "./NewSkillsPage"

export default NewSkillsPage;